import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { useEffect, useRef } from "react";
import { Toaster } from "sonner";
import { trackPageView } from "@/lib/analytics";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import ConsentBanner from "@/components/site/ConsentBanner";
import Home from "@/pages/Home";
import PropertiesPage from "@/pages/PropertiesPage";
import PropertyDetail from "@/pages/PropertyDetail";
import FAQ from "@/pages/FAQ";
import Social from "@/pages/Social";
import Neighbourhood from "@/pages/Neighbourhood";
import ManagePage from "@/pages/ManagePage";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import EventsPage from "@/pages/EventsPage";
import AboutPage from "@/pages/AboutPage";
import LandingPage from "@/pages/LandingPage";
import EventGuide from "@/pages/EventGuide";
import GuideHub from "@/pages/GuideHub";
import PetPhotoUpload from "@/pages/PetPhotoUpload";
import AdminPetPhotos from "@/pages/AdminPetPhotos";
import { landingPages } from "@/data/landingPages";
import { eventGuides } from "@/data/eventGuides";
import { guides } from "@/data/guides";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AnalyticsTracker() {
  const { pathname } = useLocation();
  const first = useRef(true);
  useEffect(() => {
    // The base snippet already tracks the initial load; only track SPA navigations.
    if (first.current) {
      first.current = false;
      return;
    }
    trackPageView(pathname);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-sand text-emerald">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <ScrollToTop />
          <AnalyticsTracker />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            {landingPages.map((p) => (
              <Route key={p.slug} path={`/${p.slug}`} element={<LandingPage config={p} />} />
            ))}
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/properties/:slug" element={<PropertyDetail />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/social" element={<Social />} />
            <Route path="/neighborhood" element={<Neighbourhood />} />
            <Route path="/neighbourhood" element={<Navigate to="/neighborhood" replace />} />
            <Route path="/events" element={<EventsPage />} />
            {eventGuides.map((g) => (
              <Route key={g.slug} path={`/events/${g.slug}`} element={<EventGuide config={g} />} />
            ))}
            {guides.map((g) => (
              <Route key={g.slug} path={`/${g.slug}`} element={<GuideHub config={g} />} />
            ))}
            <Route path="/property-management" element={<ManagePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/pet-photo-upload" element={<PetPhotoUpload />} />
            <Route path="/admin/pet-photos" element={<AdminPetPhotos />} />
          </Routes>
          <Footer />
          <Toaster position="top-center" richColors />
          <ConsentBanner />
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
